<template xmlns="http://www.w3.org/1999/html">
    <div
        class="form-element flex flex-auto font-normal"
        :class="(type == 'radio' || type == 'checkbox') ? 'radio-checkbox' : '', layoutClasses"
    >
        <Label :id="id" :required="required" :label="label" :type="type" v-if="label && fileDragDrop == false" />
        <div class="form-field-wrapper relative" :class="fieldWrapperClasses">
            <input
                :type="type"
                :id="id"
                :name="name"
                :value="(value) ? value : modelValue"
                :placeholder="placeholder"
                :min="min"
                :max="max"
                :step="step"
                :checked="checked"
                :required="required"
                :disabled="disabled"
                :readonly="readonly"
                :autofocus="autofocus"
                :multiple="multiple"
                :maxlength="maxlength"
                ref="input"
                @input="inputHandler"
                @blur="$emit('onBlur')"
                class="form-field flex-1 border border-gray-300 rounded-md focus:outline-none focus:ring-0 focus:border-blue-dark-500"
                :class="error ? 'border-red-600' : '',
                    this.type != 'radio' && this.type != 'checkbox' ? 'w-full' : '',
                    this.type == 'range' ? 'appearance-none bg-blue-dark-500 border-blue-dark-500 h-1.5 hover:opacity-85' : '',
                    this.disabled ? disabledClasses : '',
                    this.readonly ? readOnlyClasses : ''
                "
                v-if="type != 'file'"
            />
            <div
                class="flex relative z-10"
                v-if="type == 'file'"
            >
                <input
                    type="file"
                    @input="inputHandler"
                    @blur="$emit('onBlur')"
                    :id="id"
                    :name="name"
                    :required="required"
                    :accept="accept"
                    :disabled="disabled"
                    :readonly="readonly"
                    :autofocus="autofocus"
                    :multiple="multiple"
                    class="absolute z-0 opacity-0 pointer-event pointer-events-none"
                    :class="this.disabled ? disabledClasses : '',
                    this.readonly ? readOnlyClasses : ''"
                    ref="file"
                >
                <label
                    :for="id"
                    class="btn inline-block bg-blue-dark-500 px-3 py-2 text-white font-bold whitespace-nowrap rounded-l-md cursor-pointer hover:transition hover:bg-opacity-75"
                    v-if="fileDragDrop == false"
                >
                    Bestand kiezen
                </label>
                <span
                    id="file-text"
                    class="file-input pl-1 border border-l-0 border-gray-300 w-full whitespace-nowrap overflow-hidden rounded-r-md"
                    :class="{ 'border-red-600':error }"
                    v-if="fileDragDrop == false"
                >
                    {{ fileName }}
                </span>
            </div>
<!--            File(s) drag & drop -->
            <div
                class="dragdrop flex p-1 bg-blue-light-300 rounded-md font-bold"
                :style="minHeightDragDrop"
                @dragover.prevent
                @drop.prevent
                v-if="fileDragDrop"
            >
                <div class="dragdrop-inside flex flex-col w-full border border-dashed border-blue-dark-500 items-center justify-center p-4 rounded-md" @drop="dropFiles">
                    <div class="text-4xl mb-2 opacity-50">
                        <i class="fas fa-upload"></i>
                    </div>
                    <label :for="id" class="hover:cursor-pointer">
                        {{ label }}
                    </label>
                    <div v-if="droppedFiles.length" class="mt-2">
                        <template v-if="multiple">
                            <div v-for="file in droppedFiles" :key="file">
                                {{file.name}}
                            </div>
                        </template>
                        <template v-else>
                            {{ droppedFiles[0].name }}
                        </template>
                    </div>
                </div>
            </div>

            <Error :error="error" v-if="error && type != 'radio' && type != 'checkbox'" />
        </div>
    </div>
</template>
<script>
import Label from "./Label";
import Error from "./Error";

export default {
    components: {
        Label,
        Error
    },
    emits: ['update:modelValue', 'onBlur'],
    props: {
        layout: {
            type: String,
            default: 'horizontal',//vertical
        },
        label: {
            type: String,
        },
        type: {
            type: String,
            default: 'text',
        },
        name: {
            type: String,
            required: true
        },
        id: {
            type: String,
            default: (props) => props.name,
        },
        modelValue: {
            type: [String, Array, FileList, Number, Date, Boolean]
            //When there are multiple checkboxes, where the values need to be in an array and the checkboxes are checked by default.  Then pass the array values by default here
            //After that, values will be removed and added automatically when checked/unchecked in the array in the modelValue
            //e.g. I have 2 checkboxes that are checked on load --> name="mycheckboxes", v-model="form.mycheckboxes", form.mycheckboxes: ['value1', 'value2']
        },
        value: { //Use this only for radio buttons or checkboxes in some cases
            default: undefined
        },
        min: {
            type: String
        },
        max: {
            type: String
        },
        maxlength: {
            type: String
        },
        step: {
            type: Number
        },
        required: {
            type: Boolean,
            default: false
        },
        checked: {
            type: Boolean,
            default: false
        },
        getCheckboxValue: {//By default, we return true or false based on checked. With this option, we can return the value when checked, otherwise we return null
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        autofocus: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        error: {
            type: String
        },
        placeholder: {
            type: String,
            default: '',
        },
        filePlaceholder: {
            type: String,
            default: 'Geen bestand gekozen',
        },
        accept: {
            type: String,
            default: '*'
        },
        fileDragDrop: {
            type: Boolean,
            default: false
        },
        heightDragDrop: {
            type: String,
            default: '115' //in px
        }
    },
    data() {
        return {
            fileName: this.filePlaceholder,
            droppedFiles: [],
            disabledClasses: 'bg-gray-200 cursor-not-allowed',
            readOnlyClasses: 'bg-gray-200 cursor-not-allowed',
            minHeightDragDrop: 'min-height: ' + this.heightDragDrop + 'px;',
        };
    },
    computed: {
        layoutClasses() {
            //We add mb-2 here twice, because we don't need it when we have an hidden input field
            if (this.layout == 'vertical' && this.type != 'radio' && this.type != 'checkbox') {
                return 'mb-2 flex-col';
            } else if (this.type != 'hidden') {
                return 'mb-2 items-start';
            }

            return '';
        },
        fieldWrapperClasses() {
            if (this.type != 'radio' && this.type != 'checkbox') {
                return '';
            } else {
                return 'order-none min-w-[15px]';
            }
        },
    },
    methods: {
        inputHandler(e) {

            if (this.type == 'checkbox')
            {
                const value = this.value || null;  // Use the value prop or null if undefined
                // If modelValue is an array, clone it; otherwise, use the single value
                let updatedModelValue = Array.isArray(this.modelValue) ? [...this.modelValue] : this.modelValue;

                // Handle user interaction (when checkbox is clicked)
                if (e.target.checked) {
                    if (Array.isArray(updatedModelValue)) {
                        if (!updatedModelValue.includes(value)) {
                            updatedModelValue.push(value);  // Add to array if not already present
                        }
                    } else {
                        updatedModelValue = value;  // Set the value directly (single value case)
                    }
                } else {
                    if (Array.isArray(updatedModelValue)) {
                        updatedModelValue = updatedModelValue.filter(v => v !== value);  // Remove value from array
                    } else if (updatedModelValue === value) {
                        updatedModelValue = null;  // Clear the single value
                    }
                }

                // If the result is a single value, emit it directly. If it's an array, emit the array.
                this.$emit('update:modelValue', updatedModelValue);
            }
            else if (this.type != 'file' && e)
            {
                return this.$emit('update:modelValue', e.target.value)
            } else if (e)
            {
                this.fileName = e.target.files[0].name
                this.droppedFiles = e.target.files
                return this.$emit('update:modelValue', e.target.files)
            }
        },
        dropFiles(e) {
            this.droppedFiles = e.dataTransfer.files
            this.$refs.file.files = e.dataTransfer.files
            return this.$emit('update:modelValue', e.dataTransfer.files)
        }
    },
    watch: {
        modelValue: function(file) {
            //We need to reset the file input, when the form has been submitted
            if (this.type == 'file' && file === null) {
                this.$refs.file.value = null
                this.fileName = this.filePlaceholder
            }
        }
    }
}
</script>

<style>
.form-element:not(.radio-checkbox) .form-field-wrapper {
    min-width: 65%;
    flex-grow: inherit;
}

.form-element:not(.radio-checkbox) > label {
    min-width: 35%;
}

.radio-checkbox > label
{
    font-size: 0.9rem;
    line-height: 1.65rem;
}

.form-field:not(input[type='file'], input[type='range']),
.file-input {
    padding: 0.43rem 0.25rem;
}

input[type='range']::-webkit-slider-thumb {
    appearance: none;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: rgb(124, 178, 189);
    cursor: pointer;
}

input[type='range']::-moz-range-thumb {
    appearance: none;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: rgb(124, 178, 189);
    cursor: pointer;
}

input[type="search"]::-webkit-search-cancel-button {
    -webkit-appearance: none;
    appearance: none;
    height: 15px;
    width: 15px;
    background-image: url(https://pro.fontawesome.com/releases/v5.10.0/svgs/solid/times-circle.svg);
    background-size: 15px 15px;
    color: rgb(46, 52, 76);
}

</style>
